import { useModalState } from 'components/ModalProvider/index.state'
import Link from 'components/UI/Link'
import Modal from 'components/UIv2/Modal'
import { Button } from 'nzk-react-components'
import styled from 'styled-components'

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.6);
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  > :first-child {
    min-height: 0 !important;
    padding-bottom: 40px;
  }
  .title {
    font-size: 36px;
    font-family: 'Rammetto One';
    text-align: center;
    color: #fff;
    margin-bottom: 20px;
  }
  .actions {
    display: flex;
    flex-direction: column;
    > * {
      display: flex;
      flex-direction: column;
      margin-bottom: 20px;
    }
    > :last-child { margin-bottom: 0; }
  }
`

const Wrapper = styled.div`
  background-color: #fff;
`


const NotAChildModal = () => {
  const modal = useModalState()

  const dismiss = () => {
    modal.close('not-a-child-modal')
  }
  return <Overlay onClick={(e) => {
    e.stopPropagation()
    dismiss()
  }}>
      <Modal title='Not a child?' enterAnimationDelay={0} description='Log in as' dismiss={dismiss}>
        <div className='actions'>
          <a href="https://dashboard.nightzookeeper.com/login"><Button size='large' theme='confirm'>Parent</Button></a>
          <Link to='/dashboard/login'><Button size='large' theme='primary' onClick={dismiss}>Teacher</Button></Link>
        </div>
      </Modal>
  </Overlay>
}

export default NotAChildModal
